export default __webpack_public_path__ + "ee35474ac4e600e9568e24fd27e1f9ca.jpg";